module.exports = __webpack_public_path__ + "static/img/slide_5_en.dfbdca8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/live-hr-advice/slider/slide_5_en.png
// module id = DWo3
// module chunks = 0